// Copyright © 2019-2026 Focal Systems. All rights reserved.

export const LINEAR_WORKSPACE = "focalsystems";

export type LinearLinkMode = "desktop" | "web";

/** Build a Linear issue URL for the Focal workspace, desktop (app) or web. */
export function linearIssueUrl(id: string, mode: LinearLinkMode): string {
  return mode === "desktop"
    ? `linear://${LINEAR_WORKSPACE}/issue/${id}`
    : `https://linear.app/${LINEAR_WORKSPACE}/issue/${id}`;
}

/**
 * Whether ticket links open the Linear desktop app or the web.
 * TODO: source from user profile settings once available — defaults to desktop for now.
 */
export function useLinearLinkMode(): LinearLinkMode {
  return "desktop";
}
